import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImportDetail } from '@/components/ImportDetail';
import { ImportHistory } from '@/components/ImportHistory';
import { ImportWizard } from '@/components/ImportWizard';
import { Icon } from '@/components/Icon';

type View = 'wizard' | 'history';

/**
 * Imports module page — wires the three subviews (wizard, history list,
 * history detail) together. The sub-nav is the small pill-style tab bar
 * from the MAFA design system; selection is local UI state, no URL
 * hash needed for slice 3.
 */
export function ImportsPage() {
  const { t } = useTranslation();
  const [view, setView] = useState<View>('wizard');
  const [detailId, setDetailId] = useState<number | null>(null);

  function openHistoryAt(id: number) {
    setView('history');
    setDetailId(id);
  }

  return (
    <div>
      <div className="page-head">
        <div>
          <div className="pt">{t('pages.imports.title')}</div>
          <div className="ps">{t('pages.imports.subtitle')}</div>
        </div>
      </div>

      <div className="sub-nav" style={{ maxWidth: 520 }}>
        <button
          className={view === 'wizard' ? 'on' : ''}
          onClick={() => {
            setView('wizard');
            setDetailId(null);
          }}
        >
          <Icon name="upload" />
          Importer un fichier
        </button>
        <button
          className={view === 'history' ? 'on' : ''}
          onClick={() => {
            setView('history');
            setDetailId(null);
          }}
        >
          <Icon name="history" />
          Historique des imports
        </button>
      </div>

      {view === 'wizard' && <ImportWizard onDone={openHistoryAt} />}
      {view === 'history' && detailId == null && (
        <ImportHistory onOpen={(id) => setDetailId(id)} />
      )}
      {view === 'history' && detailId != null && (
        <ImportDetail id={detailId} onBack={() => setDetailId(null)} />
      )}
    </div>
  );
}
